import { Button } from '@frontend/design_system'
import styles from './styles.module.scss'
import { ImportIcon } from 'ui/icons'
import { ExportButtonProps } from './types'
import { useApiRequest } from 'hooks/useApiRequest'
import { bookingHistoryApi } from 'api'
import { downloadFile } from 'utils/downloadFile'
import { EXPORT_BUTTON_LABEL } from 'texts/bookingHistory'

export const ExportButton = ({
  disabled,
  companyId,
  pageIndex,
  pageSize,
  filters,
}: ExportButtonProps) => {
  const { apiRequest, loading } = useApiRequest(
    () =>
      bookingHistoryApi.exportBookingHistory(
        companyId,
        pageSize,
        pageIndex,
        filters
      ),
    undefined,
    undefined,
    undefined,
    false
  )
  const handleExport = async () => {
    const response = await apiRequest()
    if (response) {
      downloadFile(response)
    }
  }

  return (
    <Button
      size="small"
      typographyName="Button2"
      variant="secondary-border"
      label={EXPORT_BUTTON_LABEL}
      disabled={disabled}
      loading={loading}
      onClick={handleExport}
      iconRight={<ImportIcon color={disabled ? 'grey500' : 'blue700'} />}
      widthClassName={styles['export-button']}
    />
  )
}
